<template>
  <div class="gift-config-card">
    <div class="gift-config-card__content">
      <div class="gift-config-card__header">
        <base-icon
          :name="iconName"
          width="24"
          height="24"
          class="gift-config-card__icon"
        />
        <span class="gift-config-card__title">{{ title }}</span>
      </div>
      <div class="gift-config-card__tax">
        Taxa de {{ tax }}%
      </div>
      <div class="gift-config-card__days">
        Recebimento em {{ days }} dias úteis
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserTaxCard',
  props: {
    iconName: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    tax: {
      type: [String, Number],
      default: '3,89',
    },
    days: {
      type: [String, Number],
      default: '8',
    },
  },
}
</script>

<style lang="scss" scoped>
.gift-config-card {
  width: 100%;
  background-color: #F6F7F9;
  border-radius: 8px;

  &__content {
    padding: 16px 24px;
  }

  &__header {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 8px;
  }

  &__icon {
    color: #4E637B;
  }

  &__title {
    color: #374455;
    font-size: 18px;
  }

  &__tax {
    font-weight: 700;
    font-size: 16px;
    color: #4E637B;
    margin-bottom: 6px;
  }

  &__days {
    font-size: 14px;
    color: #5D758D;
  }
}
</style>